import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ButtonMonitoringComments } from '@/areas/market-insights/MarketInsights/components/ButtonMonitoringComments';
import { MonitoringPage } from '@/areas/market-insights/MarketInsights/pages/MonitoringPage';
import type { PageStaticData } from '@/shared/routing';

// The monitoring layout (`monitoring/route.tsx`) checks who may open this page. Its `ids` is the `_sidebar` layout's.
export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ t: 'optional', range: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <MonitoringPage ButtonMonitoringComments={ButtonMonitoringComments} />;
}
